import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import RetinaImage from './RetinaImage';

export default function Icon({ image, ...otherProps }) {
    return <RetinaImage image={image} {...otherProps} />;
}

Icon.displayName = displayName('Icon');

Icon.propTypes = {
    image: PropTypes.any.isRequired,
};
